<template>
<section class="location display-mobile" id="location">
<div class="container">
  <h3 class="caption">交通指南</h3>
  <p class="address">ADDRESS</p>
  <h4><img src="./location.jpg" />{{$store.state.info.address.name}}：{{$store.state.info.address.address}}</h4>
  <img class="map" :src="$store.state.info.address.map"/>
  <div class="detail" v-html="$store.state.info.address.transportation"></div>
</div>
</section>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"

.location
  padding-bottom: 36px
  .caption
    font-weight: 500
    padding-top: 37px
    text-align: center
    font-size: 22px
    color: rgba(var(--primary-rgb-color), 0.7)
  .address
    font-size: 13px
    color: #898989
    font-weight: 200
    // margin-top: 11px
    text-align: center
  h4
    font-size: 13px
    margin-top: 22px
    color: #3e3a39
    img
      width: 14px
      margin-right: 4px
      vertical-align: middle
  .map
    width: 100%
    margin-top: 16px
  .detail
    margin: 0
    padding: 0
    line-height: 1em
    list-style: none
    box-sizing: border-box
    /deep/ h5
      font-size: 15px
      color: #3e3a39
      padding-top: 27px
      &:after
        content: ''
        display: block
        width: 100%
        height: 1px
        margin-top: 6px
        border-top: 1px solid  #898989
    /deep/ p
      font-size: 13px
      margin-top: 12px
      line-height: 20px
      color: #898989
</style>
